/*
 * Copyright (C) 2018 Bruno López Trigo
 *
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; either version 2
 * of the License, or (at your option) any later version.

 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.

 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 */

import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import {
    TextField,
    FormControlLabel,
    Checkbox,
    Tooltip,
    Paper,
    Typography,
    Button,
    CircularProgress,
    FormControl,
    InputLabel,
    Select,
    Input,
    MenuItem
} from "@material-ui/core";
import {
    uploadDataset,
    buildClassifier,
    buildRules,
    deleteDataset, buildFingrams
} from "../global/API";
import CustomizedSnackbars from "../global/CustomizedSnackbars";
import { Redirect } from "react-router-dom";

const styles = theme => ({
    root: {
        color: "#4caf50",
        "&$checked": {
            color: "#4caf50"
        }
    },
    checked: {},
    container: {
        marginBottom:100,
        paddingTop: 100,
        paddingBottom: 20,
        paddingLeft: 20,
        paddingRight: 20,
        margin: "auto",
        width: "90%",
        textAlign: "center"
    },
    textField: {
        width: "100%"
    },
    textFieldName: {
        width: "100%",
        marginTop: 20
    },
    booleanBar: {
        display: "-webkit-flex",
        webkitFlexWrap: "wrap",
        flexWrap: "wrap",
        justifyContent: "space-around"
    },
    button: {
        width:"150px",
        marginTop: "30px",
        backgroundColor: "#4caf50",
        fontSize: "20px",
        color: "white",
        "&:hover": {
            backgroundColor: "#357a38"
        }
    },
    buttonCancel: {
        width:"150px",
        marginTop: "30px",
        backgroundColor: "#ff5f52",
        fontSize: "20px",
        color: "white",
        "&:hover": {
            backgroundColor: "#C62828"
        }
    },
    icon: {
        marginLeft: 10
    },
    file: {
        marginTop: 20
    },
    progress: {
        margin: "auto",
        marginTop: 80,
        marginBottom: 30
    },
    loader: {
        width: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        justifyItems: "center"
    },
    formControl: {
        width: "100%",
        textAlign: "left"
    }
});

class FormConfigureFURIA extends Component {
    constructor(props) {
        super(props);
        this.state = {
            algorithm: "FURIA",
            FURIAparams: {
                tnorm: 0,
                batchSize: 100,
                checkErrorRate: true,
                doNotCheckCapabilities: false,
                folds: 3,
                minNo: 2,
                numDecimalPlaces: 2,
                optimizations: 2,
                seed: 1,
                uncovAction: 0
            }
        };
        this.buildClassifier = this.buildClassifier.bind(this);
        this.changeFile = this.changeFile.bind(this);
        this.saveConfiguration = this.saveConfiguration.bind(this);
        this.cancelConfiguration = this.cancelConfiguration.bind(this);
    }
    async cancelConfiguration() {
        this.props.exitConfigurationFuria();
    }
    async saveConfiguration() {
        this.props.saveConfigurationFuria(this.state.FURIAParams);
    }

    handleClose = (event, reason) => {
        this.setState({
            error: false
        });
    };

    handleChange = name => event => {
        var regex = /^[A-Za-z0-9]{4,20}$/;
        this.setState({
            nameError: event.target.value.match(regex) ? false : true,
            [name]: event.target.value
        });
    };

    handleChangeSelect = name => event => {
        var params = this.state.FURIAparams;
        params[name] = event.target.value;
        this.setState({
            FURIAparams: params
        });
    };

    handleChangeParam = name => event => {
        var regex = /^-?[0-9]+\.?[0-9]*$/;
        var params = this.state.FURIAparams;
        params[name] = event.target.value;
        this.setState({
            FURIAparams: params,
            [name]: event.target.value.match(regex) ? false : true
        });
    };

    handleChangeBoolean = name => event => {
        var params = this.state.FURIAparams;
        params[name] = event.target.checked;
        this.setState({ FURIAparams: params });
    };

    changeFile(event) {
        this.setState({
            file: event.target.files[0]
        });
    }

    async buildClassifier() {
        if (
            !this.state.nameError &&
            !this.state.batchSize &&
            !this.state.folds &&
            !this.state.minNo &&
            !this.state.numDecimalPlaces &&
            !this.state.optimizations &&
            !this.state.seed &&
            !this.state.uncovAction &&
            this.state.file
        ) {
            this.setState({
                loading: true
            });
            var response = await uploadDataset(
                this.state.name,
                this.state.file,
                this.props.token
            );
            if (response.error) {
                if (response.status === 401) {
                    this.props.handleGlobalMessage(
                        "error",
                        this.props.language.labels[this.props.language.id].errorMessageUnauthorized

                    );
                    this.props.closeSession();
                    this.setState({
                        loading: false,
                        redirect: true
                    });
                } else {
                    this.setState({
                        loading: false,
                        error: true,
                        message: response.data
                    });
                }
            } else {
                this.setState(
                    {
                        dataset: response.data
                    },
                    async () => {
                        response = await buildClassifier(
                            this.state.name,
                            this.state.FURIAparams,
                            this.state.algorithm,
                            this.props.token
                        );
                        if (response.error) {
                            if (response.status === 401) {
                                this.props.handleGlobalMessage(
                                    "error",
                                    this.props.language.labels[this.props.language.id].errorMessageUnauthorized
                                );
                                this.props.closeSession();
                                this.setState({
                                    loading: false,
                                    redirect: true
                                });
                            } else {
                                await deleteDataset(this.state.name, this.props.token);
                                this.setState({
                                    loading: false,
                                    error: true,
                                    message: response.data
                                });
                            }
                        } else {
                            this.setState(
                                {
                                    classifier: response.data
                                },
                                async () => {
                                    response = await buildRules(
                                        this.state.name,
                                        this.state.algorithm,
                                        this.props.token
                                    );
                                    if (response.error) {
                                        if (response.status === 401) {
                                            this.props.handleGlobalMessage(
                                                "error",
                                                this.props.language.labels[this.props.language.id].errorMessageUnauthorized
                                            );
                                            this.props.closeSession();
                                            this.setState({
                                                loading: false,
                                                redirect: true
                                            });
                                        } else {
                                            await deleteDataset(this.state.name, this.props.token);
                                            this.setState({
                                                loading: false,
                                                error: true,
                                                message: response.data
                                            });
                                        }
                                    }  else {
                                        this.setState(
                                            {
                                                classifier: response.data
                                            },
                                            async () => {
                                                response = await buildFingrams(
                                                    this.state.name,
                                                    this.state.algorithm,
                                                    this.props.token,
                                                    this.props.language.id,
                                                );
                                                if (response.error) {
                                                    if (response.status === 401) {
                                                        this.props.handleGlobalMessage(
                                                            "error",
                                                            this.props.language.labels[this.props.language.id].errorMessageUnauthorized
                                                        );
                                                        this.props.closeSession();
                                                        this.setState({
                                                            loading: false,
                                                            redirect: true
                                                        });
                                                    } else {
                                                        this.setState({
                                                            loading: false,
                                                            error: true,
                                                            message: response.data
                                                        });
                                                    }
                                                } else {
                                                    this.props.handleGlobalMessage(
                                                        "success",
                                                        "Dataset " + this.state.name + this.props.language.labels[this.props.language.id].succesfullyCreated
                                                    );
                                                    this.setState({
                                                        loading: false,
                                                        ready: true
                                                    });
                                                }
                                            }
                                        );
                                    }
                                }
                            );
                        }
                    }
                );
            }
        } else if (this.props.classifierExists &&
            !this.state.nameError &&
            !this.state.batchSize &&
            !this.state.folds &&
            !this.state.minNo &&
            !this.state.numDecimalPlaces &&
            !this.state.optimizations &&
            !this.state.seed &&
            !this.state.uncovAction) {
            this.setState({
                loading: true
            });
            response = await buildClassifier(
                this.props.dataset,
                this.state.FURIAparams,
                this.state.algorithm,
                this.props.token
            );
            if (response.error) {
                if (response.status === 401) {
                    this.props.handleGlobalMessage(
                        "error",
                        this.props.language.labels[this.props.language.id].errorMessageUnauthorized
                    );
                    this.props.closeSession();
                    this.setState({
                        loading: false,
                        redirect: true
                    });
                } else {
                    this.setState({
                        loading: false,
                        error: true,
                        message: response.data
                    });
                }
            } else {
                this.setState(
                    {
                        classifier: response.data
                    },
                    async () => {
                        response = await buildRules(
                            this.props.dataset,
                            this.state.algorithm,
                            this.props.token
                        );
                        if (response.error) {
                            if (response.status === 401) {
                                this.props.handleGlobalMessage(
                                    "error",
                                    this.props.language.labels[this.props.language.id].errorMessageUnauthorized
                                );
                                this.props.closeSession();
                                this.setState({
                                    loading: false,
                                    redirect: true
                                });
                            } else {
                                this.setState({
                                    loading: false,
                                    error: true,
                                    message: response.data
                                });
                            }
                        } else {
                            this.props.handleGlobalMessage(
                                "success",
                                "Dataset " + this.state.name + this.props.language.labels[this.props.language.id].succesfullyCreated
                            );
                            this.setState({
                                    loading: false,
                                    ready: true
                                },

                                async () => {
                                    response = await buildFingrams(
                                        this.state.name,
                                        this.state.algorithm,
                                        this.props.token,
                                        this.props.language.id,
                                    );
                                    if (response.error) {
                                        if (response.status === 401) {
                                            this.props.handleGlobalMessage(
                                                "error",
                                                this.props.language.labels[this.props.language.id].errorMessageUnauthorized
                                            );
                                            this.props.closeSession();
                                            this.setState({
                                                loading: false,
                                                redirect: true
                                            });
                                        } else {
                                            this.setState({
                                                loading: false,
                                                error: true,
                                                message: response.data
                                            });
                                        }
                                    } else {
                                        this.props.handleGlobalMessage(
                                            "success",
                                            "Dataset " + this.state.name + this.props.language.labels[this.props.language.id].succesfullyCreated
                                        );
                                        this.setState({
                                            loading: false,
                                            ready: true
                                        });
                                    }
                                });
                        }
                    }
                );
            }
        } else if (!this.state.file) {
            this.setState({
                error: true,
                message: "Please upload the dataset file"
            });
        } else {
            this.setState({
                error: true,
                message: "Wrong params, please check fields"
            });
        }
    }

    async componentDidMount() {}

    render() {
        const { classes } = this.props;

        return this.state.loading ? (
            <div className={classes.loader}>
                <CircularProgress className={classes.progress} size={100} />
                <Typography variant="h3" align="center">
                    {this.props.language.labels[this.props.language.id].loading}
                </Typography>
            </div>
        ) : (
            <Fragment>
                <Paper className={classes.container}>
                    <Typography variant="h4">
                        {this.props.language.labels[this.props.language.id].build +
                        " " +
                        this.state.algorithm}
                    </Typography>
                    <form>
                        <Tooltip
                            title="Choose the T-Norm that is used as fuzzy AND-operator"
                            placement="top"
                        >
                            <FormControl className={classes.formControl}>
                                <InputLabel htmlFor="tnorm">TNorm</InputLabel>
                                <Select
                                    value={this.state.FURIAparams.tnorm}
                                    onChange={this.handleChangeSelect("tnorm")}
                                    input={<Input name="tnorm" id="tnorm" />}
                                >
                                    <MenuItem value={0}>Product T-Norm (standard)</MenuItem>
                                    <MenuItem value={1}>Minimun T-Norm</MenuItem>
                                </Select>
                            </FormControl>
                        </Tooltip>
                        <Tooltip
                            title="The preferred number of instances to process if batch prediction is being performed. More or fewer instances may be provided, but this gives implementations a chance to specify a preferred batch size"
                            placement="top"
                        >
                            <TextField
                                id="standard-name"
                                label="batchSize"
                                className={classes.textField}
                                value={this.state.FURIAparams.batchSize}
                                onChange={this.handleChangeParam("batchSize")}
                                margin="normal"
                                error={this.state.batchSize}
                            />
                        </Tooltip>
                        <Tooltip
                            title="Determines the amount of data used for pruning. One fold is used for pruning, the rest for growing the rules"
                            placement="top"
                        >
                            <TextField
                                id="standard-name"
                                label="folds"
                                className={classes.textField}
                                value={this.state.FURIAparams.folds}
                                onChange={this.handleChangeParam("folds")}
                                margin="normal"
                                error={this.state.folds}
                            />
                        </Tooltip>
                        <Tooltip
                            title="The minimum total weight of the instances in a rule"
                            placement="top"
                        >
                            <TextField
                                id="standard-name"
                                label="minNo"
                                className={classes.textField}
                                value={this.state.FURIAparams.minNo}
                                onChange={this.handleChangeParam("minNo")}
                                margin="normal"
                                error={this.state.minNo}
                            />
                        </Tooltip>
                        <Tooltip
                            title="The number of decimal places to be used for the output of numbers in the model"
                            placement="top"
                        >
                            <TextField
                                id="standard-name"
                                label="numDecimalPlaces"
                                className={classes.textField}
                                value={this.state.FURIAparams.numDecimalPlaces}
                                onChange={this.handleChangeParam("numDecimalPlaces")}
                                margin="normal"
                                error={this.state.numDecimalPlaces}
                            />
                        </Tooltip>
                        <Tooltip title="The number of optimization runs" placement="top">
                            <TextField
                                id="standard-name"
                                label="optimizations"
                                className={classes.textField}
                                value={this.state.FURIAparams.optimizations}
                                onChange={this.handleChangeParam("optimizations")}
                                margin="normal"
                                error={this.state.optimizations}
                            />
                        </Tooltip>
                        <Tooltip
                            title="The seed used for randomizing the data"
                            placement="top"
                        >
                            <TextField
                                id="standard-name"
                                label="seed"
                                className={classes.textField}
                                value={this.state.FURIAparams.seed}
                                onChange={this.handleChangeParam("seed")}
                                margin="normal"
                                error={this.state.seed}
                            />
                        </Tooltip>
                        <Tooltip
                            title="Select the action that is performed for uncovered instances"
                            placement="top"
                        >
                            <FormControl className={classes.formControl}>
                                <InputLabel htmlFor="uncovAction">uncovAction</InputLabel>
                                <Select
                                    value={this.state.FURIAparams.uncovAction}
                                    onChange={this.handleChangeSelect("uncovAction")}
                                    input={<Input name="uncovAction" id="uncovAction" />}
                                >
                                    <MenuItem value={0}>
                                        Apply rule stretching (standard)
                                    </MenuItem>
                                    <MenuItem value={1}>
                                        Vote for the most frequent class
                                    </MenuItem>
                                    <MenuItem value={2}>Reject the decision and abstain</MenuItem>
                                </Select>
                            </FormControl>
                        </Tooltip>
                        <div className={classes.booleanBar}>
                            <Tooltip
                                title="Whether check for error rate >= 1/2 is included in stopping criterion"
                                placement="top"
                            >
                                <FormControlLabel
                                    className={classes.boolean}
                                    control={
                                        <Checkbox
                                            classes={{
                                                root: classes.root,
                                                checked: classes.checked
                                            }}
                                            checked={this.state.FURIAparams.checkErrorRate}
                                            onChange={this.handleChangeBoolean("checkErrorRate")}
                                            value="checkErrorRate"
                                            color="primary"
                                        />
                                    }
                                    label="checkErrorRate"
                                />
                            </Tooltip>
                            <Tooltip
                                title="If set, classifier capabilities are not checked before classifier is built (Use with caution to reduce runtime)"
                                placement="top"
                            >
                                <FormControlLabel
                                    className={classes.boolean}
                                    control={
                                        <Checkbox
                                            classes={{
                                                root: classes.root,
                                                checked: classes.checked
                                            }}
                                            checked={this.state.FURIAparams.doNotCheckCapabilities}
                                            onChange={this.handleChangeBoolean(
                                                "doNotCheckCapabilities"
                                            )}
                                            value="doNotCheckCapabilities"
                                            color="primary"
                                        />
                                    }
                                    label="doNotCheckCapabilities"
                                />
                            </Tooltip>
                        </div>
                        <Button
                            variant="contained"
                            className={classes.button}
                            onClick={this.saveConfiguration}
                        >
                            {this.props.language.labels[this.props.language.id].saveButton}
                        </Button>
                        &nbsp;
                        &nbsp;
                        &nbsp;
                        <Button
                            variant="contained"
                            className={classes.buttonCancel}
                            onClick={this.cancelConfiguration}
                        >
                            {this.props.language.labels[this.props.language.id].cancelButton}
                        </Button>
                    </form>
                </Paper>
                <CustomizedSnackbars
                    openFail={this.state.error}
                    handleClose={this.handleClose}
                    message={this.state.message}
                />
                {this.state.redirect && <Redirect to="/" />}
                {this.state.ready && <Redirect to="/datasets" />}
            </Fragment>
        );
    }
}

FormConfigureFURIA.propTypes = {
    classes: PropTypes.object.isRequired
};

export default withStyles(styles)(FormConfigureFURIA);
